export enum ANALYTICS {
    /**
     * @value The analytics collection is paused
     */
    COLLECTION_DISABLED_WARNING = 'ANALYTICS.COLLECTION_DISABLED_WARNING',
    /**
     * @value Deactivate the Pause Analytics Collection to restart the analytics collection.
     */
    COLLECTION_DISABLED_WARNING_DESCRIPTION = 'ANALYTICS.COLLECTION_DISABLED_WARNING_DESCRIPTION',
    /**
     * @value This code will be used to send the current user's corresponding value to Google Analytics 4 and/or be stored in the page's DataLayer (that you can use in Google Tag Manager, for example).
     * GA4 requires the user property name to consist of letters, numbers, or underscores and not to be longer than 40 characters (including the 8 characters that we add). We thus recommend that you follow those same rules for the code above.
     * Please note that sending personal information (like email, name, ...) needs authorization from your coworkers to be <a href="https://gdpr-info.eu/art-4-gdpr/" target="_blank">GDPR compliant</a>.
     */
    COMPONENT_SETTINGS_GA_GTM_HELP = 'ANALYTICS.COMPONENT_SETTINGS_GA_GTM_HELP',
    /**
     * @value Click here for more info
     * @description Tooltip when you over the `?` button
     */
    DISPLAY_HELPER_LABEL = 'ANALYTICS.DISPLAY_HELPER_LABEL',
    /**
     * @value "%ENTITY_TITLE%" analytics
     * @description The title of the dialog displaying the analytics of an entity (content, article, event).
     */
    ENTITY_ANALYTICS_DIALOG_TITLE = 'ANALYTICS.ENTITY_ANALYTICS_DIALOG_TITLE',
    /**
     * @value GA4 property name:
     */
    GA_ATTR_PREVIEW = 'ANALYTICS.GA_ATTRIBUTE_PREVIEW',
    /**
     * @value Google Analytics and Tag Manager code
     */
    GA_GTM_CODE = 'ANALYTICS.GA_GTM_CODE',
    /**
     * @value DataLayer attribute (for GTM):
     */
    GTM_ATTR_PREVIEW = 'ANALYTICS.GTM_ATTRIBUTE_PREVIEW',
    /**
     * @value Hide %TOTAL% values
     */
    HIDE_X_MORE_VALUES = 'ADMIN.ANALYTICS.HIDE_X_MORE_VALUES',
    /**
     * @value Sampling period
     */
    SAMPLE_PERIOD = 'ADMIN.ANALYTICS.SAMPLE_PERIOD',
    /**
     * @value Day
     * @description The sampling period for the timeseries
     */
    SAMPLING_PERIOD_DAY = 'ADMIN.ANALYTICS.SAMPLING_PERIOD.DAY',
    /**
     * @value Month
     * @description The sampling period for the timeseries
     */
    SAMPLING_PERIOD_MONTH = 'ADMIN.ANALYTICS.SAMPLING_PERIOD.MONTH',
    /**
     * @value Week
     * @description The sampling period for the timeseries
     */
    SAMPLING_PERIOD_WEEK = 'ADMIN.ANALYTICS.SAMPLING_PERIOD.WEEK',
    /**
     * @value Show %TOTAL% more values
     */
    SHOW_X_MORE_VALUES = 'ADMIN.ANALYTICS.SHOW_X_MORE_VALUES',
}
